import apiClient from './apiClient';

export interface TaskMaterial {
  id: string;
  taskId: string;
  resourceId: string;
  quantityRequired: number;
  quantityAllocated: number;
  quantityConsumed: number;
  allocationStatus: string;
  rate?: number | string | null;
  lineAmount?: number | string | null;
  unitOfMeasure?: string | null;
  productType?: string | null;
  lineSpecification?: string | null;
  createdAt?: string;
  updatedAt?: string;
  resource?: {
    id: string;
    resourceCode: string;
    name: string;
    unitOfMeasure: string;
    resourceType: string;
    category?: string | null;
  };
}

type Envelope<T> = { success?: boolean; data?: T; error?: string };

const unwrap = <T>(response: unknown): T => {
  const r = response as { data?: unknown; status?: number };
  const body = typeof r?.status === 'number' ? r.data : response;
  const env = body as Envelope<T>;
  return env && Object.prototype.hasOwnProperty.call(env, 'data')
    ? (env.data as T)
    : (body as T);
};

class TaskMaterialsService {
  async listForTask(taskId: string): Promise<TaskMaterial[]> {
    const response = await apiClient.get<Envelope<TaskMaterial[]>>(`/tasks/${taskId}/resources`);
    return unwrap<TaskMaterial[]>(response) ?? [];
  }

  async addToTask(
    taskId: string,
    input: { resourceId: string; quantityRequired: number }
  ): Promise<TaskMaterial> {
    const response = await apiClient.post<Envelope<TaskMaterial>>(
      `/tasks/${taskId}/resources`,
      input
    );
    return unwrap<TaskMaterial>(response);
  }

  async adjustQuantity(
    taskId: string,
    taskResourceId: string,
    quantityRequired: number
  ): Promise<TaskMaterial> {
    const response = await apiClient.patch<Envelope<TaskMaterial>>(
      `/tasks/${taskId}/resources/${taskResourceId}`,
      { quantityRequired }
    );
    return unwrap<TaskMaterial>(response);
  }

  async removeFromTask(taskId: string, taskResourceId: string): Promise<void> {
    await apiClient.delete<void>(`/tasks/${taskId}/resources/${taskResourceId}`);
  }
}

export default new TaskMaterialsService();
